module.exports = __webpack_public_path__ + "static/img/cea.b95a66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cea.png
// module id = 234
// module chunks = 6